var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',{attrs:{"label":_vm.itemText,"value":_vm.itemValue,"input-value":_vm.value,"color":_vm.color,"hide-details":"","disabled":_vm.disabled},on:{"click":_vm.doFunction,"change":_vm.onchange}})
}
var staticRenderFns = []

export { render, staticRenderFns }